import  PartnersListEmptyContent from './PartnersListEmptyContent';
export default PartnersListEmptyContent
